import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import classNames from "classnames";

import Tab from "./Tab/Tab";
import DividerVertical from "../Divider/DividerVertical";

import { getOptionKey } from "../../utils/select";

import { TAB_SIZE, TAB_VARIANT, TAB_COLOR } from "./Tab/Tab.constants";
import { handleKeyDownNavigation } from "../../utils/keyboard-navigation/keyboard-navigation";

import styles from "./TabBar.module.scss";

const TabBar = ({
  className,
  activeTabClassName,
  tabClassName,

  withDividers,
  alignLeft,

  style,
  current,
  tabVariant,
  tabSize,
  tabColor,
  options,
  onSelectTab,
  onLockTab,
}) => {
  const { t } = useSharedTranslation();

  const refRoot = useRef();

  const handleKeyDown = (e) => handleKeyDownNavigation(refRoot.current, e);

  return (
    <div
      ref={refRoot}
      tabIndex={0}
      role="tablist"
      className={classNames(className, styles["root"], "tab-wrap", {
        [styles["align-left"]]: alignLeft,
        [styles["tab-size-sm"]]: tabSize === TAB_SIZE.sm,
      })}
      style={style}
      onKeyDown={handleKeyDown}
    >
      {options.map((item, index) => {
        const key = getOptionKey(item);
        const { isLocked, isActive } = item;
        const isSelected = key === current;

        const jsxTab = (
          <Tab
            className={tabClassName}
            classNameActive={activeTabClassName}

            number={index + 1}

            isActive={isActive}
            isLocked={isLocked}
            isSelected={isSelected}

            variant={tabVariant}
            size={tabSize}
            color={tabColor}

            onSelect={onSelectTab ? () => onSelectTab(key) : undefined}
            onLock={onLockTab ? () => onLockTab(key) : undefined}
          >
            {t(item.label)}
          </Tab>
        );

        return (
          <React.Fragment key={index}>
            {withDividers && index !== 0 && <DividerVertical className={styles["divider"]} />}
            {jsxTab}
          </React.Fragment>
        );
      })}
    </div>
  );
};

TabBar.tabVariant = TAB_VARIANT;
TabBar.tabSize = TAB_SIZE;
TabBar.tabColor = TAB_COLOR;

TabBar.defaultProps = {
  tabVariant: TAB_VARIANT.underlined,
};

TabBar.propTypes = {
  className: PropTypes.string,
  current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tabVariant: PropTypes.oneOf(Object.values(TAB_VARIANT)),
  tabSize: PropTypes.oneOf(Object.values(TAB_SIZE)),
  tabColor: PropTypes.oneOf(Object.values(TAB_COLOR)),
  style: PropTypes.object,
  options: PropTypes.array,
  onSelectTab: PropTypes.func,
  onLockTab: PropTypes.func,
};

export default TabBar;
